/**
 * creditSaleModificationGuard — BUG-2355.
 *
 * A Credit Sale retrieved from Sales History ("Retrieve Credit Sale",
 * SMPurchaseReturnView.js stamps cart.isCreditSale === "Y") is settled under the
 * ORIGINAL sOrderID / documentno, and syncOrders sends the whole cart to
 * confirmPOSLayawayOrder1, which overwrites the original order's lines, totals and
 * payment. Every item-level cart mutation (add, qty change, price edit, delete,
 * row edit, grouping, addons, custom attributes, manual discount, coupon) is
 * therefore blocked unless the till explicitly opts in via
 * posConfig.allowModificationInCreditSale === "Y". Centralized here so every call
 * site checks the same condition.
 */
export function isCreditSaleModificationBlocked(cart, posConfig) {
  return cart?.isCreditSale === "Y" && posConfig?.allowModificationInCreditSale !== "Y";
}

export const CREDIT_SALE_MODIFICATION_BLOCKED_MESSAGE = "Cannot modify a Credit Sale order";
